module.exports = __webpack_public_path__ + "img/dg.6a15aaa8.png";